import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'md-modal-actions',
  templateUrl: './modal-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalActionsComponent {}
